function Footer() {
  return (
    <div role="contentinfo" className="footer text-center">
      <p>Copyright © Léna Clavier 2022 (UX/UI Mélissa Gilly 2021)</p>
    </div>
  );
}

export default Footer;
